import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { useEffect, useRef } from "react";
import L from 'leaflet';

const LoacationMaps: React.FunctionComponent<{ position: any, zoomValue: any, address: any, height: any }> = (props) => {

    const mapRef = useRef<any>(null);
    const MAPBOX_ACCESS_TOKEN = "sk.eyJ1Ijoia2FvdXRhcjM0NTYiLCJhIjoiY203aXl1OW1iMDFvNTJrc2N5MjVxaTM5dyJ9.liGIzZ8bLftpvi635AiVYw";
    const MAPBOX_STYLE = "mapbox/streets-v11";

    const customIcon = new L.Icon({
        iconUrl: "/assets/images/icons/custom-marker.svg",
        iconSize: [50, 60],
        iconAnchor: [25, 60],
        popupAnchor: [0, -60]
    });

    useEffect(() => {
        if (mapRef.current) {
            mapRef.current.flyTo(props.position, props.zoomValue);
        }
    }, [props.position, props.zoomValue]);

    return (

        <div className="map-container">
            <MapContainer style={{ height: props.height }} center={props.position} zoom={props.zoomValue} ref={mapRef}>
                <TileLayer
                    url={`https://api.mapbox.com/styles/v1/${MAPBOX_STYLE}/tiles/{z}/{x}/{y}?access_token=${MAPBOX_ACCESS_TOKEN}`}
                    attribution=""
                />
                <Marker position={props.position} icon={customIcon}>
                    {props.address && (
                        <Popup>
                            {props.address?.subCommunity}, {props.address?.Community}, {props.address?.city}
                        </Popup>
                    )}
                </Marker>
            </MapContainer>
        </div>

    );
};

export default LoacationMaps;